import { ProblemDetails } from "@repo/rq-api-public";
import { ApiValidationError } from "@repo/rq-api-public/customTypes";

// Helper function to extract user-friendly error message from generalErrors
export const extractErrorMessage = (generalErrors: unknown): string => {
  if (Array.isArray(generalErrors)) {
    return generalErrors
      .map((err) => {
        if (typeof err === "string") return err;
        if (err && typeof err === "object" && "message" in err)
          return String(err.message);
        return "An error occurred";
      })
      .join(". ");
  }

  if (typeof generalErrors === "string") {
    return generalErrors;
  }

  if (
    generalErrors &&
    typeof generalErrors === "object" &&
    "message" in generalErrors
  ) {
    return String(generalErrors.message);
  }

  return "An error occurred";
};

export const handleApiErrors =
  <T extends string>(
    setGeneralErrors: (errors: any) => void,
    setValidationError?: (error: ApiValidationError<T>) => void,
  ) =>
  (error: unknown) => {
    if (error instanceof ProblemDetails && error.status === 400) {
      if (setValidationError && error.errors?.length > 0) {
        const errors = error.errors as ApiValidationError<T>[];
        errors.forEach(({ field, message }) => {
          if (!field || !message) return;
          setValidationError({ field, message });
        });
      } else {
        setGeneralErrors(error.errors);
      }
    }
  };

export function getApiErrorMessage(
  error: unknown,
  fallbackMessage = "An unknown error occured",
) {
  if (error instanceof ProblemDetails && error.errors?.length > 0) {
    const errors = error.errors as ApiValidationError<string>[];
    return errors.map(({ message }) => message).join(", ");
  }
  return (error as ProblemDetails)?.title ?? fallbackMessage;
}
